import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import { DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import { Col, Form, Row } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { __MessageTypes } from '../../../common/Dictionaries';
import { isNullOrEmpty, isNullUndefined, isNullUndefinedOrEmpty, showMessage } from '../../../common/Helpers';
import MessageBoxInfoComplex from '../../../components/Common/Message/MessageBoxInfoComplex';
import PropTypes from 'prop-types';
import CTextAreaSimple from '../../../components/Common/CTextAreaSimple';
import { setCommentEdP } from '../../../services/sPay/edpConfig.service';
import { FILE_MAX_SIZE } from '../../../configurations/application.config';
import { action_updateEdPPrepareForceGetButtons, action_updateEdPPrepareForceGetHeader, action_updateEdPPrepareForceGetResult } from '../../../reducers/actions/PAY/edpPrepareActions';
import { addTransversalDocument } from '../../../services/sBook/document.service';
import { TooltipHost } from '@fluentui/react';
import { envBlobDocumentUpload, envDocumentGetUrl, envDocumentValidate } from '../../../services/Env/transversal.service';

const SidePanelAddEdPPartieComment = (props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const { 
        inputParam_PartieId = null,
        inputParam_ElementId = null,
        inputParam_EdPId = null,
        inputParam_IsPanelOpen = null,
        inputParam_SetterIsPanelOpen = null,
    } = props;

    const [partieComment, setPartieComment] = useState({
        comment: undefined,
        document: null,
        documentLink: {
            mask: null,
            url: null,
        }
    });

    const [commentAdded, setCommentAdded] = useState(false);
    const [selectedFile, setSelectedFile] = useState(undefined);
    
    const [messageConfig, setMessageConfig] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });

    const onDismissPanel = () => {
        setPartieComment({
            comment: undefined,
            document: null,
            documentLink: {
                mask: null,
                url: null,
            }
        })
        setSelectedFile(undefined);
        showMessage(setMessageConfig, false, null, null)
        inputParam_SetterIsPanelOpen && inputParam_SetterIsPanelOpen(false)
    };

    const onClosePanel = () => {
        onDismissPanel();
    };

    const handleFileInput = (e) => {
        const file = e.target.files[0];
        if (file) {
            const maxSizeInMB = FILE_MAX_SIZE;
            const maxSizeInBytes = maxSizeInMB * 1024 * 1024;

            if (file.size > maxSizeInBytes) {
                showMessage(setMessageConfig, true, __MessageTypes.WARNING, t('data-lang-msg-filesizeerror'))
                setSelectedFile(null);
            }
            else {
                setSelectedFile(file);
            }
        }
    };
    
    const onRenderFooterContent = () => {
        return  <Row>
                    <Col xl={12} className="message-verybottom-panel-medium">
                        <MessageBoxInfoComplex
                            inputParam_Message={ messageConfig.message }
                            inputParam_Display={ messageConfig.showMessage }
                            inputParam_MessageType={ messageConfig.messageType }
                            inputParam_SetterMessage={ setMessageConfig }
                            inputParam_ShowClose={true}
                        />
                    </Col>
                    <Col xl={12}>
                        {
                            !commentAdded &&
                            <PrimaryButton className='mx-2' onClick={ onAddComment }>{ t('data-lang-btn-add') }</PrimaryButton>
                        }
                        <DefaultButton className='mx-2' onClick={ onClosePanel }>{ t('data-lang-btn-close') }</DefaultButton>
                    </Col>
                </Row>
    }

    const prepareObjetToSave = () => {
        return {
            id: 0,
            estadoPagoId: inputParam_EdPId,
            estadoPagoPartidaId: inputParam_PartieId,
            textoFijo: "",
            textoComentario: partieComment.comment,
            // Fecha la estampa el backend con DateTime.Now (N_EdpMensajeHandler.Grabar); no se manda
            // desde acá para no depender del reloj/zona horaria del cliente.
            rol: "",
            userAuthProfileId: 0,
            automatico: false,
            nombreApellido: "",
            documentoUrl: "",
            documentoLink: "",
            documentId: 0,
        }
    }

    const validateObject = (object) => {
        let isValid = !isNullUndefinedOrEmpty(object) && !isNullUndefinedOrEmpty(object.comment);

        if (!isValid) {
            setPartieComment(prevState => ({
                ...prevState,
                comment: null
            }));
        }

        return isValid;
    };

    const onAddComment = async () => {       
        if (validateObject(partieComment)) {
            await setCommentEdP(inputParam_ElementId, prepareObjetToSave()).then(async (serviceResponse) => {
                if (serviceResponse.data.succeeded) {
                    if (serviceResponse.data.data.result) {
                        if (!isNullUndefined(selectedFile)) {
                            //const formData = new FormData();
                            //formData.append("file", selectedFile);
                            //formData.append('id', serviceResponse.data.data.itemId);
                            //formData.append("url", 'Pay/edp/documents');

                            await envDocumentGetUrl('Pay/edp/documents', serviceResponse.data.data.itemId, selectedFile.name).then(async (responseGetUrl) => {
                                if (responseGetUrl.data.succeeded === true) {
                                    await envBlobDocumentUpload(responseGetUrl.data.data.url, responseGetUrl.data.data.fileName, selectedFile).then(async (responseAzure) => {
                                        if (responseAzure.data === "" && responseAzure.status === 201) {
                                            await envDocumentValidate(responseGetUrl.data.data.document_id).then(async (responseValidate) => {
                                                if (responseValidate.data.succeeded === true) {
                                                    if (responseValidate.data.data.result_validate === true) {
                                                        dispatch(action_updateEdPPrepareForceGetHeader(true));
                                                        dispatch(action_updateEdPPrepareForceGetResult(true));
                                                        dispatch(action_updateEdPPrepareForceGetButtons(true));

                                                        showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'));
                                                        setCommentAdded(true)
                                                        setSelectedFile(undefined)
                                                    }
                                                    else {
                                                        showMessage(setMessageConfig, true, __MessageTypes.ERROR, t(responseValidate.data.data.result_validate_msg));
                                                        setCommentAdded(false)
                                                    }
                                                }
                                                else {
                                                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t(responseValidate.data.message));
                                                    setCommentAdded(false)
                                                }
                                            })
                                            .catch((error) => {
                                                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-documentoperationerror'));
                                                setCommentAdded(false)
                                            });
                                        }
                                        else {
                                            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-documentoperationerror'));
                                            setCommentAdded(false)
                                        }
                                    })
                                    .catch(async (error) => {
                                        await envDocumentValidate(responseGetUrl.data.data.document_id, 0).then(async () => {
                                            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-documentoperationerror'));
                                            setCommentAdded(false)
                                        })
                                        .catch((error) => {
                                            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-documentoperationerror'));
                                            setCommentAdded(false)
                                        });
                                    });
                                } else {
                                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t(responseGetUrl.data.message));
                                    setCommentAdded(false)
                                }
                                setSelectedFile(null);
                            })
                            .catch(() => {
                                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-documentoperationerror'));
                                setCommentAdded(false)
                            });
                        }
                        else {
                            dispatch(action_updateEdPPrepareForceGetHeader(true));
                            dispatch(action_updateEdPPrepareForceGetResult(true));
                            dispatch(action_updateEdPPrepareForceGetButtons(true));

                            showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'));
                        }
                    }
                    else {
                        showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-documentoperationerror'));
                    }
                }
                else {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'));
                    setCommentAdded(false)
                }  
            }).catch(() => {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'));
                setCommentAdded(false)
            });
        }
        else {
            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-requireddatanotset'));
            setCommentAdded(false)
        }
    };

    const onChangeMessageText = (e) => {
        const { value } = e.currentTarget;
        setPartieComment(prevState => ({
            ...prevState,
            comment: value
        }));
    }

    return (
        <div>
            <Panel
                isOpen={ inputParam_IsPanelOpen }
                isBlocking={true}
                onDismiss={ onDismissPanel }
                headerText={ inputParam_PartieId === null ? t('data-lang-boxname-edpcomment') : t('data-lang-boxname-partiecomment') }
                closeButtonAriaLabel={ t('data-lang-btn-close') }
                isFooterAtBottom={ true }
                onRenderFooterContent={ onRenderFooterContent }
                customWidth={ PanelType.medium }
                type={ PanelType.medium }
            >
                <fieldset disabled={commentAdded}>
                    <Row>
                        <Col>
                            <Row className='pt-3'>
                                <Col xs={12}>
                                    <CTextAreaSimple
                                        editMode={true}
                                        //maxLength={1000}
                                        labelText={ t('data-lang-lbl-comment') }
                                        controlValue={ partieComment.comment } 
                                        textBoxName={'action'}
                                        setterControlValue={onChangeMessageText}
                                        isInvalirControl={partieComment ? isNullOrEmpty(partieComment.comment) : false}
                                    />
                                </Col>
                            </Row>
                            <Row className='pt-3'>
                                <Col><b>{t('data-lang-msg-documentasociated')}</b></Col>
                                <Col>
                                    <TooltipHost content={
                                        <>
                                            <div>{'Tool TIP Archivos Permitidos: "7z", "doc", "docx", "eml", "jpeg", "jpg", "msg", "ods", "pdf", "png", "ppt", "pptx", "rar", "txt", "xls", "xlsb", "xlsx", "xps", "zip“. Peso: 80mb.'}</div>
                                            <div>{'Si tiene problemas con estos formatos, sugerimos guardar nuevamente el archivo con un programa estándar, ejemplo: Archivo de imagen “.jpg”  o “.png” utilizar abrir en “Paint” y volver a guardar.'}</div>
                                        </>
                                    }>
                                        <Form.Control type="file" size="sm" onChange={ handleFileInput } />
                                    </TooltipHost>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </fieldset>
            </Panel>
        </div>
    );
};

SidePanelAddEdPPartieComment.propTypes = {
    inputParam_IsPanelOpen: PropTypes.bool.isRequired,
    inputParam_SetterIsPanelOpen: PropTypes.func.isRequired,
};

export default SidePanelAddEdPPartieComment;